'use strict';

angular.module('AcaApp').factory('ResetDataService',
[
  'SettingsResource',
  function(SettingsResource){
    return{
      resetCurrentData: function(entity){
        var rpcConfig = {method: 'ResetCurrentData', params: [entity]};
        return SettingsResource.executeRpc(rpcConfig).$promise;
      }
    };
  }
]);